import { render, staticRenderFns } from "./PaxInputHorizontal.vue?vue&type=template&id=7759fb2c&scoped=true&"
import script from "./PaxInputHorizontal.vue?vue&type=script&lang=js&"
export * from "./PaxInputHorizontal.vue?vue&type=script&lang=js&"
import style0 from "./PaxInputHorizontal.vue?vue&type=style&index=0&id=7759fb2c&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7759fb2c",
  null
  
)

export default component.exports